angular.module('impactx.rfx').controller('RFXEditInternalItemCtrl', [
    'TranslationService',
    '$mdDialog',
    'RFXBuyerService',
    RFXEditInternalItemController
]);

function RFXEditInternalItemController(TranslationService, $mdDialog, RFXBuyerService) {
    var self = this;
    self.itemCopy = angular.copy(self.item, self.itemCopy);
    self.trns.save = TranslationService.get('save');
    self.trns.abort = TranslationService.get('abort');
    activate();

    self.save = function () {
        self.itemCopy.isInternal = true;
        self.itemCopy.id = self.itemCopy.id || 0;
        $mdDialog.hide(self.itemCopy);
    };

    self.abort = function () {
        $mdDialog.cancel();
    };

    function activate() {
        var itemId = impactX.isDefined(self, 'item.id');
        if (!itemId && itemId !== 0) {
            RFXBuyerService.getItemData(self.rfqhId, 0, 0, 0, true).then(function (item) {
                self.itemCopy = item;
            });
        }
    }
}